export interface IEnkHeaderProps {
  text: string
}

export function EnkHeader(props: IEnkHeaderProps) {
  const { text } = props
  return <h2 className="mt-8 text-2xl font-bold leading-9 tracking-tight text-gray-900">{text}</h2>
}
